// src/api.js
import secureLocalStorage from "react-secure-storage";

const BASE_URL = 'https://api-k8s.engiv.io';

const API_URL = 'https://api2.engiv.io';//'http://localhost:3000';//

function getHeader() {
  const _token = secureLocalStorage.getItem('access_token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${_token}`
  };
}

const refreshToken = async () => {
  try {
    const refresh_token = secureLocalStorage.getItem('refresh_token');
    if (refresh_token) {
      const response = await fetch(`${API_URL}/refresh-token`, {
        method: 'POST',
        credentials: 'include',
        body: refresh_token,
      });

      console.log("call to refresh token response", response);
      if (!response.ok) {
        console.error("Failed to refresh token");
        return null;
      }

      const { access_token } = await response.json();
      secureLocalStorage.setItem("access_token", access_token);
      return access_token;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error refreshing token:", error);
    return null;
  }
};

export const loginApi = async (username, password) => {
  try {
    const response = await fetch(`${API_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ username, password }),
    });

    if (response.ok) {
      const data = await response.json();
      const accessToken = data.access_token;
      if (accessToken) {
        secureLocalStorage.setItem('access_token', accessToken);
        secureLocalStorage.setItem('refresh_token', data.refresh_token);
        secureLocalStorage.setItem('patient_id', data.patient_id);
        secureLocalStorage.setItem('isAuthenticated', true);
        return { data, message: '' }
      } else {
        return { data: null, message: 'No access token received' }
      }
    } else {
      return { data: null, message: 'That password doesn’t match. Try again or reset it.' }
    }
  } catch (error) {
    return { data: null, message: error }
  }
};

export const loginMemberStackApi = async (memberstack_id) => {
  try {
    const response = await fetch(`${BASE_URL}/userbymsid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ memberstack_id }),
    });

    console.log(response);
    if (response.ok) {
      const data = await response.json();
      secureLocalStorage.setItem('patient_id', data.patient_id);
      secureLocalStorage.setItem('isAuthenticated', true);
      return { data, message: '' }
    } else {
      return { data: null, message: 'That password doesn’t match. Try again or reset it.' }
    }
  } catch (error) {
    return { data: null, message: error }
  }
};

export const getInsights = async (patientId) => {
  try {
    const response = await fetch(`${BASE_URL}/insights`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ patientId }),
    });

    if (!response.ok) {
      throw new Error('Insights API request failed');
    }

    const result = await response.json();
    return result.message;
  } catch (error) {
    console.error('Error fetching insights:', error);
    return 'Error fetching data';
  }
};

export const getWeeklyTaskProgress = async (patient_id, task_id, is_preventive, complete) => {
  try {
    const response = await fetch(`${BASE_URL}/weekly-task-progress`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ patient_id, task_id, is_preventive, complete }),
    });

    if (!response.ok) {
      throw new Error('Weekly task progress API request failed');
    }

    const result = await response.json();
    return result.progress;
  } catch (error) {
    console.error('Error fetching weekly task progress:', error);
    return 'Error fetching data';
  }
};

export const getTasks = async (patientId, week_no) => {
  try {
    const response = await fetch(`${BASE_URL}/tasks/${patientId}/${week_no}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('getTasks API request failed');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching insights:', error);
    return 'Error fetching data';
  }
};

export const getProgress = async (patientId) => {
  try {
    const response = await fetch(`${BASE_URL}/progress`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ patientId }),
    });

    if (!response.ok) {
      throw new Error('Insights API request failed');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching progress:', error);
    return 'Error fetching data';
  }
};

export const getLastCheckIn = async (patientId) => {
  try {
    const response = await fetch(`${BASE_URL}/checkin/${patientId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ patientId }),
    });

    if (!response.ok) {
      throw new Error('Insights API request failed');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching checkin:', error);
    return 'Error fetching data';
  }
};

export const getChat = async (data) => {
  try {
    const response = await fetch(`${BASE_URL}/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("Error in getChat:", error);
    throw error;
  }
};

export const getSentiment = async (data) => {
  try {
    const response = await fetch(`${BASE_URL}/sentiment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("Error in getSentiment:", error);
    throw error;
  }
};

export const setTask = async (patient_id, task_id, checked) => {
  try {
    console.log("postData", { patient_id, task_id, checked })
    const response = await fetch(`${API_URL}/tasks/patient-done`, {
      method: 'POST',
      headers: getHeader(),
      body: JSON.stringify({ patient_id, task_id, checked }),
    });
    if (response.status === 401) {
      console.log("Token expired. Attempting to refresh...");
      const newToken = await refreshToken();
      if (newToken) {
        return setTask(patient_id, task_id, checked);
      }
    } else if (response.ok) {
      return true;
    } else {
      throw new Error('API request failed');
    }
  } catch (error) {
    console.error('Error fetching details:', error);
    return false;
  }
};

export const getResources = async (week_no, type, isPreventive) => {
  try {
    const response = await fetch(`${BASE_URL}/resource?week_no=${week_no}&type=${type}&is_preventive=${isPreventive}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 401) {
      console.log("Token expired. Attempting to refresh...");
      const newToken = await refreshToken();
      if (newToken) {
        return getResources(week_no, type, isPreventive);
      }
    } else if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      throw new Error('Resources API request failed');
    }
  } catch (error) {
    console.error('Error fetching resources:', error);
    return null;
  }
};

export const getPatientInfo = async () => {
  try {
    const response = await fetch(`${API_URL}/patient-detail`, {
      method: 'GET',
      headers: getHeader(),
      credentials: 'include',
    });

    console.log("getPatientInfo", response);
    if (response.status === 401) {
      const newToken = await refreshToken();
      if (newToken != null) {
        return getPatientInfo();
      }
    } else if (!response.ok) {
      throw new Error('Patient details API request failed');
    }

    const result = await response.json();
    console.log("patient_information", result);
    secureLocalStorage.setItem('patient_info', result);
    return result;
  } catch (error) {
    console.error('Error fetching patient details:', error);
    return null;
  }
};

export const getTreatmentPlan = async (patientId) => {
  try {
    const response = await fetch(`${BASE_URL}/treatment-plan`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ patientId }),
    });

    if (!response.ok) {
      throw new Error('Treatment plan API request failed');
    }

    const result = await response.json();
    return result.plan;
  } catch (error) {
    console.error('Error fetching treatment plan:', error);
    return 'Error fetching treatment plan';
  }
};

export const getRomGallery = async (patientId) => {
  try {
    const response = await fetch(`https://api2.engiv.io/rom/patient/${patientId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error in getRomGallery:", error);
    throw error;
  }
};

export const getClinicalAnalysis = async (data) => {
  try {
    const response = await fetch(`${BASE_URL}/clinical_analysis`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Clinical analysis API request failed');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching clinical analysis:', error);
    return 'Error fetching clinical analysis';
  }
};

export const updateProgress = async (patient_id, pain, motivation, activity, week_no) => {
  try {
    const response = await fetch(`${BASE_URL}/update-progress`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ patient_id, pain, motivation, activity, week_no }),
    });

    if (!response.ok) {
      throw new Error('Update progress API request failed');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error updating progress:', error);
    return 'Error updating progress';
  }
};
